// @flow
import * as React from "react";
import { connect } from "react-redux";
import TextInput from "../controls/text-input";
import SVGIcon from "../svg-icon";
import { icons } from "../svg-icon";
import { listCompanyUsersFacilities } from "../../redux/reducers/company-reducer";
import TabSelectorRibbon from "../controls/tab-selector-ribbon";
import { ListCompanyAlerts } from "../../redux/reducers/alerts-reducer";
import { listFacilityAlerts } from "../../redux/reducers/alerts-reducer";
import { listFacilityAlertUsers } from "../../redux/reducers/alerts-reducer";
import PrevSwitch from "../controls/prev-switch";
import AlertRow from "./alert-row";
import { listUserAlertFacilities } from "../../redux/reducers/alerts-reducer";
import { updateUserAlertFacility } from "../../redux/reducers/alerts-reducer";

type Props = {
  facilityId: number,
  userId: number,
  facilities: Array<any>,
  listCompanyUsersFacilities: Function,
  listFacilityAlerts: Function,
  alerts: Array<any>
};

type State = {
  textSearch: string,
  selectedFacilityId: number
};

class UserAlertList extends React.Component<Props, State> {
  state = {
    textSearch: "",
    selectedFacilityId: 0
  };

  componentDidMount() {
    this.props
      .listCompanyUsersFacilities(this.props.userId)
      .then(() => this.setFacility((this.props.facilities[0] || {}).id));
  }

  handleChanges = e => {
    const name = e.target.name || e.target.attributes["name"].value;
    const value = e.target.value;
    const checked = e.target.checked;
    switch (name) {
      case "textSearch":
        this.setState({ [name]: value });
        break;
      case "email":
        this.props.updateUserAlertFacility(
          this.state.selectedFacilityId,
          value.alert_facility,
          value.id,
          checked,
          value.push_notifications,
          value.user_company
        );
        break;
      case "push":
        this.props.updateUserAlertFacility(
          this.state.selectedFacilityId,
          value.alert_facility,
          value.id,
          value.email_notifications,
          checked,
          value.user_company
        );
        break;
      default:
    }
  };

  render() {
    return (
      <div>
        <div style={{ width: "250px", margin: "auto" }}>
          <TextInput
            value={this.state.textSearch}
            label="Buscar por instalaciones"
            name="textSearch"
            onChange={this.handleChanges}
            suffix={{
              element: (
                <SVGIcon
                  name={icons.search}
                  fill="#AFC8FF"
                  style={{ right: "0%", position: "absolute" }}
                />
              )
            }}
          />
        </div>
        <div>
          <TabSelectorRibbon
            activeId={this.state.selectedFacilityId}
            items={this.props.facilities
              .filter(f => f.code.includes(this.state.textSearch))
              .map(f => ({
                id: f.id,
                description: f.code
              }))}
            onChange={e =>
              this.setFacility((e.target.attributes["name"] || {}).value)
            }
          />
        </div>
        <div>
          {this.props.alerts.map(ca => (
            <AlertRow
              alert={ca}
              key={ca.id}
              onAlertDataChange={() => {}}
              onLevelDataChange={this.handleChanges}
              loadEmailList={() => {}}
              mode={"alerts-compact"}
            />
          ))}
        </div>
      </div>
    );
  }

  alertLevelConfig = (push: boolean = false, email: boolean = false) => {
    return (
      <React.Fragment>
        <PrevSwitch handleClick={() => {}} checked={push} />

        <PrevSwitch handleClick={() => {}} checked={email} />
      </React.Fragment>
    );
  };

  setFacility = id => {
    // if (id) {
    this.props.listUserAlertFacilities(this.props.userId);
    this.setState({ selectedFacilityId: parseInt(id) });
    this.props.listFacilityAlerts(id);
    // }
  };
}

const mapStateToProps = state => {
  const alerts = state.alerts.companyAlerts.data
    .map(ca => {
      const levels = state.alerts.facilityAlerts.data
        .filter(
          fa =>
            fa.alerts === ca.id &&
            state.alerts.userFacilityAlerts.data.find(
              ufa => ufa.alert_facility === fa.id
            )
        )
        .map(fa => ({
          ...fa,
          alertFacility: state.alerts.userFacilityAlerts.data.find(
            ufa => ufa.alert_facility === fa.id
          )
        }))
        .sort((a, b) => a.level - b.level)
        .map(fa => ({
          alertFacility: fa.alertFacility,
          id: fa.id,
          status: fa.status,
          level: fa.level,
          emails: { email_list: [], user_list: [] },
          push: fa.alertFacility.push_notifications,
          email: fa.alertFacility.email_notifications
        }));
      const active =
        levels.filter(lvl => lvl.push || lvl.email).length > 0 ? true : false;
      return {
        id: ca.id,
        name: ca.name,
        description: ca.description,
        levels,
        active
      };
    })
    .filter(ca => ca.levels.length > 0);
  return {
    alerts,
    userFacilityAlerts: state.alerts.userFacilityAlerts.data,
    facilities: state.companyReducer.companyUsersFacilities.data || [],
    facilityAlerts: state.alerts.facilityAlerts.data
  };
};
const mapDispatchToProps = dispatch => {
  dispatch(ListCompanyAlerts());
  return {
    listCompanyUsersFacilities: userId =>
      dispatch(listCompanyUsersFacilities(userId)),
    listFacilityAlerts: facilityId => dispatch(listFacilityAlerts(facilityId)),
    listFacilityAlertUsers: (facilityId, alertFacilityId) =>
      dispatch(listFacilityAlertUsers(facilityId, alertFacilityId)),
    listUserAlertFacilities: userId =>
      dispatch(listUserAlertFacilities(userId)),
    updateUserAlertFacility: (
      facility_id,
      alert_facility_id,
      id,
      email_notifications,
      push_notifications,
      user_company
    ) =>
      dispatch(
        updateUserAlertFacility(
          facility_id,
          alert_facility_id,
          id,
          email_notifications,
          push_notifications,
          user_company
        )
      )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserAlertList);
